import {
  format as format_en,
  formatDistanceToNow as formatDistanceToNow_en,
} from 'date-fns';
import { enGB, faIR } from 'date-fns/locale';
import {
  format as format_fa,
  formatDistanceToNow as formatDistanceToNow_fa,
} from 'date-fns-jalali';
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';

export function useTime() {
  function dateLocaleSelector() {
    const localeBasedFormat = {
      en: {
        format: format_en,
        formatDistanceToNow: formatDistanceToNow_en,
        locale: enGB,
      },
      fa: {
        format: format_fa,
        formatDistanceToNow: formatDistanceToNow_fa,
        locale: faIR,
      },
    };
    const { locale: localeComp = { value: 'en' } } = useI18n();
    const locale = localeComp.value;
    if (locale in localeBasedFormat) {
      return localeBasedFormat[locale];
    }
    return localeBasedFormat.en;
  }
  const { format, formatDistanceToNow } = dateLocaleSelector();
  return {
    formatDistanceToNow,
    format,
  };
}
